import request from '@webtrader/core/request';

import { ESimple2TradeAccountType, IUserProfile } from './index';

export enum EPasswordType {
  PASS_MAIN,
  PASS_INVESTOR,
  PASS_API
}

export const passwordTypeMapping = (accountType: ESimple2TradeAccountType) => {
  return accountType === ESimple2TradeAccountType.INV ? EPasswordType.PASS_INVESTOR : EPasswordType.PASS_MAIN;
};

export interface ISwitchAccountParams {
  metatraderId: number;
  passwordType?: EPasswordType;
  serverId?: number; // only required if OMS
}

export interface ISwitchAccountResponse {
  switchedAccountToken: string;
}

export default {
  get: () => {
    return request.get<IUserProfile>('/api/user/v1/account');
  },
  switch: (params: ISwitchAccountParams) => {
    return request.patch<ISwitchAccountResponse>('/api/user/v1/account', params);
  }
};
